import dualPlayer from './module/dual-player';

const DELIVERY_CAP = 1; // 100%
const PLAYLIST_DELIVERY_CAP = 1; // 100%
const pixelsAdTag =
  'https://pubads.g.doubleclick.net/gampad/ads?iu=/22844376944/AA/tennisnet/tennisnet/video/instream&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&env=vp&unviewed_position_start=1&url=[REFERRER_URL]&correlator=&adrule=0&plcmt=2';

window.pixelsDualInject = dualPlayer({
  contextualDeliveryCap: DELIVERY_CAP,
  playlistDeliveryCap: PLAYLIST_DELIVERY_CAP,
  organisation: 'tennisnet',
  playlist: __ENV_MODE__ === 'prod' ? '8da776db-2ddd-49e6-b4c9-80cf2bfd00a4' : 'd440c9d9-d5e2-49bb-833c-c52ce67c98ad',
  midArticlePlaylist: __ENV_MODE__ === 'prod' ? 'not-available' : '84488ff3-af3d-4ef5-b8eb-dd2bfa5dcb78',
  adTagUrlPromise: Promise.resolve(pixelsAdTag),
});
